import React, { PropsWithChildren } from 'react';
import VideoPlayerModal from '@/Components/VideoPlayerModal';
import axios from 'axios';

interface Props {
  videoSrc: string;
  videoTitle: string;
}

// onClode function
const onClose = () => {
  axios.patch('/api/onboarding-video-played');
};

export default function OnboardingVideo({
  videoSrc,
  videoTitle,
}: PropsWithChildren<Props>) {
  return (
    <VideoPlayerModal
      videoUrl={videoSrc}
      isOpen={true}
      title={videoTitle}
      onClose={onClose}
    ></VideoPlayerModal>
  );
}
